<section class="astral-stack-m">
  <h2 class="astral-section-heading">{{ 'ERRAND_TAG.PROPERTY_RESPONSIBILITY' | translate }}</h2>
  @for (row of rows; track row.form; let i = $index) {
    <div
      class="astral-section-surface astral-section-surface--compact astral-section-surface--subtle astral-stack-s"
      [formGroup]="row.form"
    >
      @if (row.historicalReadonly) {
        <astral-chip labelKey="ERRAND_TAG.HISTORICAL_DISABLED_RESPONSIBILITY"></astral-chip>
      }
      <astral-layout-group [columns]="5" [tabletColumns]="2" [mobileColumns]="1">
        <astral-select
          [control]="row.form.controls['errandTagId']"
          [itemsSource]="row.tagSelection"
        ></astral-select>
        <astral-typeahead [control]="row.form.controls['resourceId']" [itemsSource]="row.resources"></astral-typeahead>
        <astral-typeahead [control]="row.form.controls['executorGroupId']" [itemsSource]="row.executorGroups"></astral-typeahead>
        <astral-typeahead [control]="row.form.controls['executorWebUserId']" [itemsSource]="row.executorWebUsers"></astral-typeahead>
        <div class="astral-form-adjacent-action astral-form-adjacent-action--end">
          <astral-button
            variant="secondary"
            type="button"
            icon="trash"
            labelKey="DELETE_BTN"
            [disabled]="row.historicalReadonly"
            (click)="remove(i)"
          ></astral-button>
        </div>
      </astral-layout-group>
    </div>
  }
  <div class="astral-form-actions astral-form-actions--start">
    <astral-button
      variant="primary"
      type="button"
      icon="plus"
      labelKey="ERRAND_TAG.ADD_RESPONSIBILITY"
      [disabled]="loading || saving || !canAddResponsibility"
      (click)="add()"
    ></astral-button>
  </div>
</section>
